webpackJsonp([5],{

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(243);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ee94f43_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(263);
function injectStyle (ssrContext) {
  __webpack_require__(261)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ee94f43_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('dashboard', ['presentations'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('dashboard', ['fetchPresentations', 'createNewPresentation', 'renamePresentation', 'deletePresentation']), {
    createNew: function createNew() {
      return this.createNewPresentation();
    }
  }),
  created: function created() {
    this.fetchPresentations();
  }
});

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(262);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("51bcf51a", content, true, {});

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, ".user-dashboard{display:grid;grid-template-rows:auto 1fr;grid-template-areas:\"dashboard-header\" \"my-presentations\";overflow-y:scroll}@media only screen and (device-width:375px) and (device-height:812px) and (-webkit-device-pixel-ratio:3){.user-dashboard{padding:0 calc(env(safe-area-inset-right) + .5em) 0 calc(env(safe-area-inset-left) + .5em)}}.dashboard-header{grid-area:dashboard-header;padding:2em;-ms-flex-item-align:start;align-self:start;height:auto}.my-presentations{grid-area:my-presentations;padding:0 2em 2em;display:grid;grid-gap:2em;grid-template-columns:repeat(auto-fit,350px);grid-template-rows:250px;grid-auto-rows:250px}.my-presentations>a{border:3px solid transparent;background-color:#fff;color:var(--dark-grey);border-radius:5px;cursor:pointer;-webkit-transition:all .3s ease-out;transition:all .3s ease-out;overflow:visible;min-height:0;min-width:0;display:grid;grid-template-columns:1fr;grid-template-rows:1fr auto}.my-presentations>a:first-child{background-color:rgba(0,0,0,.3);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.my-presentations>a:first-child:hover{background-color:rgba(0,0,0,.4)}.my-presentations>a:first-child i{font-size:4em}.my-presentations>a .preview{background:-webkit-gradient(linear,left top,right bottom,from(purple),to(pink));background:linear-gradient(to bottom right,purple,pink);color:rgba(0,0,0,.6);font-weight:700;font-size:1.2em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.my-presentations>a:hover:not(.create){border-color:var(--primary-colour);-webkit-box-shadow:0 1px 5px rgba(0,0,0,.3);box-shadow:0 1px 5px rgba(0,0,0,.3);-webkit-transform:translateY(-3px);transform:translateY(-3px)}.my-presentations>a:hover .pres-info .title{color:var(--primary-colour)}.pres-info{padding:1em;-webkit-box-shadow:0 -2px 0 rgba(0,0,0,.2);box-shadow:0 -2px 0 rgba(0,0,0,.2);display:inline-grid;grid-gap:.5em;grid-template-areas:\"title        manage\" \"last-opened  manage\";grid-template-columns:minmax(auto,1fr) auto;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.pres-info,.pres-info *{overflow:hidden;min-height:0;min-width:0}.pres-info{overflow:visible}.pres-info .title{grid-area:title;font-weight:700}.pres-info .last-opened{grid-area:last-opened;color:var(--medium-grey);font-size:.9em}.pres-info .last-opened .date,.pres-info .last-opened .edited-by{font-weight:700}.pres-info .manage{grid-area:manage;border-radius:5px 5px 0 0;height:2.5em;width:2.5em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;overflow:visible}.pres-info .manage ul{position:absolute;top:100%;left:0;width:200px;border-radius:0 5px 5px 5px;color:#fff;visibility:hidden;opacity:0;display:grid}.pres-info .manage ul li a{display:grid;grid-gap:1em;grid-template-columns:auto 1fr;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:.7em .9em}.pres-info .manage ul li a i{font-size:1.4em}.pres-info .manage ul li a:hover{background-color:var(--primary-colour);-webkit-transition:all .4s;transition:all .4s}.pres-info .manage:hover{color:#fff}.pres-info .manage:hover,.pres-info .manage ul{background-color:rgba(0,0,0,.6);-webkit-transition:all .4s;transition:all .4s}.pres-info .manage:hover ul{visibility:visible;opacity:1;-webkit-transition:all .4s;transition:all .4s}@media (orientation:landscape) and (max-width:820px),(orientation:portrait) and (max-width:300px){.my-presentations{grid-template-columns:1fr;grid-template-rows:125px;-ms-flex-line-pack:start;align-content:start}.my-presentations>a .preview{display:none}}", "", {"version":3,"sources":["/home/forge/slidekick.daniel-waghorn.com/src/components/Dashboard.vue"],"names":[],"mappings":"AACA,gBACE,aAAc,AACd,4BAA6B,AAC7B,0DAGC,AACD,iBAAmB,CACpB,AAGD,yGAIA,gBACI,0FAA6F,CAChG,CACA,AACD,kBACE,2BAA4B,AAC5B,YAAa,AACb,0BAA2B,AACvB,iBAAkB,AACtB,WAAa,CACd,AACD,kBACE,2BAA4B,AAC5B,kBAAuB,AAEvB,aAAc,AACd,aAAc,AACd,6CAA+C,AAC/C,yBAA0B,AAC1B,oBAAuB,CACxB,AACD,oBACE,6BAA8B,AAC9B,sBAAwB,AACxB,uBAAwB,AACxB,kBAAmB,AACnB,eAAgB,AAChB,oCAAsC,AACtC,4BAA8B,AAE9B,iBAAkB,AAClB,aAAc,AACd,YAAa,AAEb,aAAc,AACd,0BAA2B,AAC3B,2BAA6B,CAC9B,AACD,gCACE,gCAAqC,AACrC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,sCACE,+BAAqC,CACtC,AACD,kCACE,aAAe,CAChB,AACD,6BACE,gFAAqF,AACrF,wDAA2D,AAC3D,qBAA0B,AAC1B,gBAAkB,AAClB,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,uCACE,mCAAoC,AACpC,4CAAiD,AACzC,oCAAyC,AACjD,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,4CACE,2BAA6B,CAC9B,AACD,WACE,YAAa,AAEb,2CAAgD,AAExC,mCAAwC,AAEhD,oBAAqB,AACrB,cAAgB,AAChB,gEAGC,AACD,4CAA8C,AAC9C,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,wBAEE,gBAAiB,AACjB,aAAc,AACd,WAAa,CACd,AACD,WACE,gBAAkB,CACnB,AACD,kBACE,gBAAiB,AACjB,eAAkB,CACnB,AACD,wBACE,sBAAuB,AACvB,yBAA0B,AAC1B,cAAiB,CAClB,AACD,iEAEE,eAAkB,CACnB,AACD,mBACE,iBAAkB,AAClB,0BAA2B,AAC3B,aAAc,AACd,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,kBAAmB,AACnB,gBAAkB,CACnB,AACD,sBACE,kBAAmB,AACnB,SAAU,AACV,OAAQ,AACR,YAAa,AACb,4BAA6B,AAC7B,WAAa,AACb,kBAAmB,AACnB,UAAW,AAEX,YAAc,CACf,AACD,2BACE,aAAc,AACd,aAAc,AACd,+BAAgC,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,iBAAqB,CACtB,AACD,6BACE,eAAiB,CAClB,AACD,iCACE,uCAAwC,AACxC,2BAA6B,AAC7B,kBAAqB,CACtB,AACD,yBACE,UAAa,CACd,AACD,+CAEE,gCAAqC,AACrC,2BAA6B,AAC7B,kBAAqB,CACtB,AACD,4BACE,mBAAoB,AACpB,UAAW,AACX,2BAA6B,AAC7B,kBAAqB,CACtB,AACD,kGAGA,kBACI,0BAA2B,AAC3B,yBAA0B,AAC1B,yBAA0B,AACtB,mBAAqB,CAC5B,AACD,6BACI,YAAc,CACjB,CACA","file":"Dashboard.vue","sourcesContent":["\n.user-dashboard {\n  display: grid;\n  grid-template-rows: auto 1fr;\n  grid-template-areas:\n    \"dashboard-header\"\n    \"my-presentations\"\n  ;\n  overflow-y: scroll;\n}\n\n/* Add extra side padding for iphone X users */\n@media only screen \n      and (device-width : 375px) \n      and (device-height : 812px) \n      and (-webkit-device-pixel-ratio : 3) {\n.user-dashboard {\n    padding: 0 calc(env(safe-area-inset-right) + 0.5em) 0 calc(env(safe-area-inset-left) + 0.5em)\n}\n}\n.dashboard-header {\n  grid-area: dashboard-header;\n  padding: 2em;\n  -ms-flex-item-align: start;\n      align-self: start;\n  height: auto;\n}\n.my-presentations {\n  grid-area: my-presentations;\n  padding: 0 2em 2em 2em;\n\n  display: grid;\n  grid-gap: 2em;\n  grid-template-columns: repeat(auto-fit, 350px);\n  grid-template-rows: 250px;\n  grid-auto-rows:  250px;\n}\n.my-presentations > a {\n  border: 3px solid transparent;\n  background-color: white;\n  color: var(--dark-grey);\n  border-radius: 5px;\n  cursor: pointer;\n  -webkit-transition: 0.3s all ease-out;\n  transition: 0.3s all ease-out;\n\n  overflow: visible;\n  min-height: 0;\n  min-width: 0;\n\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr auto;\n}\n.my-presentations > a:first-child {\n  background-color: rgba(0, 0, 0, 0.3);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.my-presentations > a:first-child:hover {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.my-presentations > a:first-child i {\n  font-size: 4em;\n}\n.my-presentations > a .preview {\n  background: -webkit-gradient(linear, left top, right bottom, from(purple), to(pink));\n  background: linear-gradient(to bottom right, purple, pink);\n  color: rgba(0, 0, 0, 0.6);\n  font-weight: bold;\n  font-size: 1.2em;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.my-presentations > a:hover:not(.create) {\n  border-color: var(--primary-colour);\n  -webkit-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);\n  -webkit-transform: translateY(-3px);\n          transform: translateY(-3px);\n}\n.my-presentations > a:hover .pres-info .title {\n  color: var(--primary-colour);\n}\n.pres-info {\n  padding: 1em;\n\n  -webkit-box-shadow: 0 -2px 0 rgba(0, 0, 0, 0.2);\n\n          box-shadow: 0 -2px 0 rgba(0, 0, 0, 0.2);\n\n  display: inline-grid;\n  grid-gap: 0.5em;\n  grid-template-areas:\n    \"title        manage\"\n    \"last-opened  manage\"\n  ;\n  grid-template-columns: minmax(auto, 1fr) auto;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.pres-info,\n.pres-info * {\n  overflow: hidden;\n  min-height: 0;\n  min-width: 0;\n}\n.pres-info {\n  overflow: visible;\n}\n.pres-info .title {\n  grid-area: title;\n  font-weight: bold;\n}\n.pres-info .last-opened {\n  grid-area: last-opened;\n  color: var(--medium-grey);\n  font-size: 0.9em;\n}\n.pres-info .last-opened .date,\n.pres-info .last-opened .edited-by {\n  font-weight: bold;\n}\n.pres-info .manage {\n  grid-area: manage;\n  border-radius: 5px 5px 0 0;\n  height: 2.5em;\n  width: 2.5em;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  position: relative;\n  overflow: visible;\n}\n.pres-info .manage ul {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 200px;\n  border-radius: 0 5px 5px 5px;\n  color: white;\n  visibility: hidden;\n  opacity: 0;\n\n  display: grid;\n}\n.pres-info .manage ul li a {\n  display: grid;\n  grid-gap: 1em;\n  grid-template-columns: auto 1fr;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 0.7em 0.9em;\n}\n.pres-info .manage ul li a i {\n  font-size: 1.4em;\n}\n.pres-info .manage ul li a:hover {\n  background-color: var(--primary-colour);\n  -webkit-transition: 0.4s all;\n  transition: 0.4s all;\n}\n.pres-info .manage:hover {\n  color: white;\n}\n.pres-info .manage:hover,\n.pres-info .manage ul {\n  background-color: rgba(0, 0, 0, 0.6);\n  -webkit-transition: 0.4s all;\n  transition: 0.4s all;\n}\n.pres-info .manage:hover ul {\n  visibility: visible;\n  opacity: 1;\n  -webkit-transition: 0.4s all;\n  transition: 0.4s all;\n}\n@media\n(orientation: landscape) and (max-width: 820px),\n(orientation: portrait) and (max-width: 300px) {\n.my-presentations {\n    grid-template-columns: 1fr;\n    grid-template-rows: 125px;\n    -ms-flex-line-pack: start;\n        align-content: start;\n}\n.my-presentations > a .preview {\n    display: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-dashboard"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"my-presentations"},[_c('a',{staticClass:"create",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.createNew($event)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_vm._l((_vm.presentations),function(presentation){return _c('router-link',{key:presentation.id,attrs:{"to":{ name: 'editor', params: { presentationId: presentation.id }}},on:{"click":function($event){_vm.setPageLoading(true)}}},[_c('div',{staticClass:"preview"},[_vm._v("\n        "+_vm._s(presentation.title)+"\n      ")]),_vm._v(" "),_c('span',{staticClass:"pres-info"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(presentation.title))]),_vm._v(" "),_c('span',{staticClass:"last-opened"},[_vm._v("Edited "),_c('span',{staticClass:"date"},[_vm._v("Thu 15 Feb")]),_vm._v(" by "),_c('span',{staticClass:"edited-by"},[_vm._v("Paul")])]),_vm._v(" "),_c('a',{staticClass:"manage",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_c('i',{staticClass:"material-icons"},[_vm._v("more_vert")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.renamePresentation(presentation)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")]),_vm._v(" "),_c('span',[_vm._v("Rename presentation")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.deletePresentation(presentation.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")]),_vm._v(" "),_c('span',[_vm._v("Delete presentation")])])])])])])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-header"},[_c('h3',[_vm._v("My Presentations")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.cb31b2df0da46f9ddc69.js